import { LittleModalCreateEdit } from '../../../../../../../baseComponents/ModalsLayouts/ModalCreateEdit'
import { FormRender } from '../../../../../../../forms/FormRenderer/types'
import useTwinTranslation from '../../../../../../../utils/hooks/useTwinTranslation'
import { ModalEditComponentProps } from '../../../../../../../baseComponents/ModalsLayouts/types'
import { valueOrDefaultValue } from '../../../../../../../utils/globals/valueOrDefaultValue'
import { permissionCheck } from '../../../../../../../baseComponents/PermissionChecker/function'
import { getAllGroupVats } from '../../../../../../../utils/reducers/getters'
import { CostBuyModelType } from '@teinor/erp/types/company/config/cost/costBuy'

interface ModalCECostBuyProps extends ModalEditComponentProps {}

const ModalCECostBuy: React.FC<ModalCECostBuyProps> = ({ allRowData, userPermissions, ...rest }) => {
    const groupVats = getAllGroupVats()
    const { t } = useTwinTranslation()
    const fields: FormRender<CostBuyModelType> = [
        {
            cols: 1,
            elements: [
                {
                    name: 'name',
                    label: t('name', 'Nombre'),
                    component: 'InputWithLabelMargin',
                    type: 'text',
                    required: true,
                },
                {
                    name: 'GroupVatId',
                    label: t('groupVat', 'Grupo de impuestos'),
                    component: 'CustomSelectWithSearchBar',
                    items: groupVats || {},
                    value: allRowData?.GroupVatId,
                    required: true,
                },
                {
                    name: 'id',
                    component: 'InputHidden'
                }
            ]
        },
    ]
    
    if (allRowData && userPermissions) {
        const parsedFields = valueOrDefaultValue(fields, userPermissions, allRowData)
        return (<LittleModalCreateEdit fields={parsedFields} url={'/api/app/config/cost/costBuy/updateCostBuy'} translations={{ title: t('editCostBuy', 'Editar coste de compra'), button: t('save', 'Guardar') }} haveButtonPermissions={permissionCheck(userPermissions, 'update')} {...rest} />)
    }
    return (<LittleModalCreateEdit fields={fields} url={'/api/app/config/cost/costBuy/createCostBuy'} translations={{
        title: t('createCostBuy', 'Crear coste de compra'),
        button: t('create', 'Crear')
    }} haveButtonPermissions={true} {...rest} />)
}

export default ModalCECostBuy